module.exports = __webpack_public_path__ + "img/49.41d0e770.jpg";